import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService, LocalStorageCache } from '@auth0/auth0-angular';

@Component({
  selector: 'app-auth-error',
  templateUrl: './auth-error.component.html',
  styleUrls: ['./auth-error.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AuthErrorComponent implements OnInit {

  public error$: Observable<any> = this.auth.error$;

  public unknownError?: string;

  public shouldShowGenericError = false;

  protected readonly JSON = JSON;

  constructor(private auth: AuthService, private router: Router) {

  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      this.shouldShowGenericError = window.location.pathname === '/auth-error';
    });

    // Delete the token from Auth0 when we arrive on this page.
    const localStorageCache = new LocalStorageCache();
    localStorageCache.allKeys().forEach(key => {
      localStorageCache.remove(key);
    });

    this.error$.subscribe(error => {
      console.error('Error Description:' + error.error_description);

      switch (error.error_description) {
        case 'email_not_verified':
          this.shouldShowGenericError = false;
          this.router.navigateByUrl('/auth-error/email-not-verified');
          break;
        default:
          this.unknownError = error;
          break;
      }

      console.error(error);
    });
  }
}
